// Use singular base path
const BASE = '/api/student'
const apiurl = process.env.REACT_APP_API_URL

// src/api.js

async function handleRes(res) {
  const text = await res.text();
  let json = {};
  try { json = text ? JSON.parse(text) : {}; } catch (e) { json = { message: text }; }
  if (!res.ok) {
    const msg = json.message || json.error || res.statusText || `HTTP ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    err.body = json;
    throw err;
  }
  return json;
}

export const adminLogin = async (data) => {
  const res = await fetch(`${apiurl}/api/admin/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return handleRes(res);
};

export const changeAdminPassword = async ({ oldPassword, newPassword, token } = {}) => {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(`${apiurl}/api/admin/change-password`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ oldPassword, newPassword }),
  });
  return handleRes(res);
};


export async function listStudents(){
  const r = await fetch(`${apiurl}${BASE}`) // GET /api/student
  if (!r.ok) throw new Error('Failed to load students')
  return r.json()
}

export async function createStudent(fd){
  const r = await fetch(`${apiurl}${BASE}`, { method:'POST', body: fd })
  if (!r.ok) throw new Error((await r.json()).message || 'Create failed')
  return r.json()
}

export async function updateStudent(id, fd){
  const r = await fetch(`${apiurl}${BASE}/${id}`, { method:'PUT', body: fd })
  if (!r.ok) throw new Error((await r.json()).message || 'Update failed')
  return r.json()
}

export async function deleteStudent(id){
  const r = await fetch(`${apiurl}${BASE}/${id}`, { method:'DELETE' })
  if (!r.ok) throw new Error((await r.json()).message || 'Delete failed')
  return r.json()
}

// ---------------------------------------
// ADMIN FORGOT PASSWORD (SEND OTP)
// ---------------------------------------
// api.js
export const adminForgotPassword = async () => {
  const res = await fetch(`${apiurl}/api/admin/forgot-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  return handleRes(res);
};



// ---------------------------------------
// ADMIN RESET PASSWORD WITH OTP
// ---------------------------------------
export const adminResetPassword = async ({ username, otp, newPassword } = {}) => {
  const res = await fetch(`${apiurl}/api/admin/reset-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, otp, newPassword }),
  });
  return handleRes(res);
};

